import { render, staticRenderFns } from "./kirimKwitansiModal.vue?vue&type=template&id=5bd260d4&scoped=true"
import script from "./kirimKwitansiModal.vue?vue&type=script&lang=js"
export * from "./kirimKwitansiModal.vue?vue&type=script&lang=js"
import style0 from "./kirimKwitansiModal.vue?vue&type=style&index=0&id=5bd260d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd260d4",
  null
  
)

export default component.exports